export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  ConsumerFintech: {
    CheckoutConversion: {
      EmbeddedCheckoutF19: {
        flag: 'consumerfintech_jgcheckout_conversion_embedded_checkout_f19',
        excludedFlag:
          'consumerfintech_jgcheckout_conversion_embedded_checkout_f19_applepay',
      },
    },
  },
};
